// extracted by mini-css-extract-plugin
module.exports = {"root":"ListingDetails_root__qCfzN"};